import window from "global";
import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";

interface ButtonSuccessProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  label?: any;
  disable?: boolean;
  isLoading?: boolean;
  success?: boolean;
  bForceSubmitOnEnter?: boolean;
}

export default function ButtonSuccess(props: ButtonSuccessProps) {
  const [init, setInit] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);

  const { className, label, disable, isLoading, success, bForceSubmitOnEnter, ...otherProps } = props;

  useEffect(() => {
    function handleKeyPress(e: KeyboardEvent) {
      if (e.key === "Enter") {
        if (buttonRef && buttonRef.current) {
          buttonRef.current.click();
        }
      }
    }

    if (window && bForceSubmitOnEnter) {
      document.addEventListener("keydown", handleKeyPress, false);
      return () => document.removeEventListener("keydown", handleKeyPress, false);
    }
  }, [bForceSubmitOnEnter]);

  const onClickHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!disable && otherProps?.onClick) {
      otherProps.onClick(e);
    }
  };

  const buttonClassNames = classnames(className, "btn-success", {
    "btn-success_disable": disable,
    "btn-success_loading": init && isLoading,
    "btn-success_toggle": init && success,
  });

  return (
    <div className={buttonClassNames} {...otherProps} ref={buttonRef} onClick={onClickHandler}>
      <img className="btn-checkmark" src={"https://static.bigbrain.gg/assets/ugg/icons/checkmark-white.svg"} alt="Checkmark" />
      {isLoading ? (
        <img className="btn-loader" src={"https://static.bigbrain.gg/assets/ugg/icons/spinny-boy.svg"} alt="Loader" />
      ) : (
        <div className="btn-label">{label}</div>
      )}
    </div>
  );
}
